import React, { useEffect } from 'react';
import Card from '@amzn/meridian/card';
import Column from '@amzn/meridian/column';
import Text from '@amzn/meridian/text';
import { breadcrumbsForView, useImageQualityFilters } from './useImageQualityFilters';
import AllSitesView from './AllSitesView';
import SiteView from './SiteView';
import AssociateDetail from './AssociateDetail';
import ReportWindowBar from './ReportWindowBar';
import { Breadcrumbs } from './meridianUi';
import { logImageQualityAction } from './api';
import { IMAGE_QUALITY_PAGE_VIEW } from '../../utils/metric-utils';

/**
 * Evidence image-quality report: All sites › own site › associate. All state lives in
 * useImageQualityFilters; this is layout only. The site is the Boson-selected station.
 */
const ImageQualityReport: React.FC = () => {
  const filters = useImageQualityFilters();
  useEffect(() => {
    logImageQualityAction(IMAGE_QUALITY_PAGE_VIEW);
  }, []);
  // The mock puts the date range under each view's headline tiles.
  const windowBar = <ReportWindowBar filters={filters} />;

  return (
    <Column spacing="500" spacingInset="500">
      {!filters.stationCode && (
        <Card spacingInset="500">
          <Text color="secondary">Select a site in RCC to view image quality.</Text>
        </Card>
      )}

      {filters.stationCode && <Breadcrumbs crumbs={breadcrumbsForView(filters)} />}

      {filters.stationCode && filters.view.kind === 'allSites' && (
        <AllSitesView
          ownSite={filters.stationCode}
          reportWindow={filters.reportWindow}
          windowLabel={filters.windowLabel}
          windowBar={windowBar}
          onOpenOwnSite={filters.showSite}
          onDataAvailableFrom={filters.noteDataAvailableFrom}
        />
      )}
      {filters.stationCode && filters.view.kind === 'site' && (
        <SiteView
          warehouseId={filters.stationCode}
          reportWindow={filters.reportWindow}
          windowLabel={filters.windowLabel}
          windowBar={windowBar}
          onSelectAssociate={filters.showAssociate}
          onDataAvailableFrom={filters.noteDataAvailableFrom}
        />
      )}
      {filters.stationCode && filters.view.kind === 'associate' && (
        <AssociateDetail
          warehouseId={filters.stationCode}
          reportWindow={filters.reportWindow}
          windowLabel={filters.windowLabel}
          login={filters.view.login}
          onDataAvailableFrom={filters.noteDataAvailableFrom}
        />
      )}
    </Column>
  );
};

export default ImageQualityReport;
